export const STORY_STATUS = Object.freeze({
  QUEUED: 'queued',
  GENERATING: 'generating',
  READY: 'ready',
  FAILED: 'failed',
});

export const ASSET_STATUS = Object.freeze({
  DISABLED: 'disabled',
  QUEUED: 'queued',
  GENERATING: 'generating',
  PARTIAL: 'partial',
  COMPLETED: 'completed',
  FAILED: 'failed',
});

export const STORY_STATE_VERSION = 1;

export const isAssetPending = (status) => [
  ASSET_STATUS.QUEUED,
  ASSET_STATUS.GENERATING,
  ASSET_STATUS.PARTIAL,
].includes(status);

export const getStoryStatusLabel = (story) => {
  if (!story) return 'Story unavailable';
  if (story.generation_status === STORY_STATUS.FAILED) return 'Needs attention';
  if ([ASSET_STATUS.FAILED, ASSET_STATUS.PARTIAL].includes(story.images_status)
    || [ASSET_STATUS.FAILED, ASSET_STATUS.PARTIAL].includes(story.audio_status)) {
    return 'Needs attention';
  }
  if (story.generation_status === STORY_STATUS.READY && !isAssetPending(story.images_status) && !isAssetPending(story.audio_status)) {
    return story.images_status === ASSET_STATUS.DISABLED ? 'Text only' : 'Ready to read';
  }
  return 'Processing';
};

export const toUserSafeError = (error, fallback = 'Something went wrong. Please try again.') => {
  const message = String(error?.message || error || '').toLowerCase();
  if (message.includes('timeout') || message.includes('504')) {
    return 'This is taking longer than expected. Your story is safe; try again when you are ready.';
  }
  if (message.includes('storage') || message.includes('upload')) {
    return 'The story text is safe, but an optional picture or audio asset could not be saved yet.';
  }
  if (message.includes('unauthorized') || message.includes('forbidden')) {
    return 'Your session needs to be refreshed before this can continue.';
  }
  return fallback;
};

export const buildStoryState = ({ imageModel = 'none', audioEnabled = false, now = new Date().toISOString() } = {}) => ({
  state_version: STORY_STATE_VERSION,
  generation_status: STORY_STATUS.GENERATING,
  images_status: imageModel === 'none' ? ASSET_STATUS.DISABLED : ASSET_STATUS.QUEUED,
  audio_status: audioEnabled ? ASSET_STATUS.QUEUED : ASSET_STATUS.DISABLED,
  asset_retry_count: 0,
  last_attempt_at: null,
  updated_at: now,
});
